import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { useLocation } from 'react-router';
import { GetSideMenuItems, IGetSideMenuItemsProps } from './GetSideMenuItems';
import { asideMenuItems, developersAsideMenuItems } from './asideItems';
import { AsideMenuItem } from './AsideMenuItem';
import { logout } from '../../redux/AuthCRUD';
import * as auth from '../../redux/AuthRedux';
import { IAuthState } from '../../redux/AuthRedux';
import { useNavigate } from 'react-router-dom';
import { sendSentryMessage } from '../../utils/sentry-helper';
import { faAddressCard, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';


export function AsideMenuMain(): JSX.Element {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	const { pathname } = useLocation();

	const onLogout = async (): Promise<void> => {
		try {
			await logout(authUser?.accessToken);
		} catch (e) {
			sendSentryMessage({ name: `Logout error`, context: e });
			console.log('e', e);
		}
		console.log('logout---008');
		dispatch(auth.actions.logout());
		navigate('/');
	};

	useEffect(() => {
		if (pathname) {
			let redirectUrl = '';
			if (pathname.includes('error') ||
			pathname.includes('not-found') ||
			pathname.includes('stripe') ) {
				redirectUrl = '/dashboard';
			} else {
				redirectUrl = pathname;
			}
			localStorage.setItem('redirectUrl', redirectUrl);
		}
	}, [pathname]);

	const getAsideNavigationItems = (): IGetSideMenuItemsProps[] => {
		switch (true) {
			case checkRoles(authUser, CLAIMS.SUPER_ADMIN):
			case checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN):
			case checkRoles(authUser, CLAIMS.PARTNER_ADMIN): {
				return asideMenuItems?.filter((asideItem) => {
						if (checkRoles(authUser, asideItem?.claim)) {
							return asideItem;
						}
					});
			}
			case checkRoles(authUser, CLAIMS.MERCHANT_ADMIN):
			case checkRoles(authUser, CLAIMS.MERCHANT_SUPPORT):
			case checkRoles(authUser, CLAIMS.MERCHANT_SUPPORT_ADMIN):
			case checkRoles(authUser, CLAIMS.MERCHANT_FINANCE):
			case checkRoles(authUser, CLAIMS.MERCHANT_DEVELOPER): {
				return developersAsideMenuItems?.filter((asideItem) => {
					if (checkRoles(authUser, asideItem?.claim)) {
						return asideItem;
					}
				});
			}
		}
	};

	return (
		<>
			{
				getAsideNavigationItems()?.map((item: IGetSideMenuItemsProps) => (
						<GetSideMenuItems
							key={item.path}
							{...item}
						/>
					))
			}
			<div className="menu-item d-lg-none">
				<div className="menu-content">
					<div className="border-bottom mx-1 my-4"/>
				</div>
			</div>
			<div className="d-lg-none">
				<AsideMenuItem
					title="Profile"
					to="/profile"
					icon={faAddressCard}
				/>
			</div>
			<div className="menu-item d-lg-none" onClick={onLogout} data-cy="sign-out">
				<AsideMenuItem
					title="Sign out"
					to="#"
					icon={faArrowRightFromBracket}
				/>
			</div>
		</>
	);
}
